import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=a1202992"
import script from "./LoginForm.vue?vue&type=script&lang=ts"
export * from "./LoginForm.vue?vue&type=script&lang=ts"
import style0 from "./LoginForm.vue?vue&type=style&index=0&id=a1202992&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports